//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import EmptyReports from '../../../../_common/Draw/EmptyReports';
import NoData from '../../../NoData';

export const NoDataMessage = () => (
  <NoData>
    <NoDataInner container direction="column" alignItems="center">
      <EmptyReports />
      <Typography data-testid="no-data-message" variant="h6">No Reports Available</Typography>
    </NoDataInner>
  </NoData>
);

const NoDataInner = styled(Grid)`
  display: flex;
  flex-direction: column;

  & .MuiTypography-root {
    margin-top: ${({ theme }) => theme.spacing(3)};
  }

  & svg {
    width: 100%;
  }
`;
